import { ShieldCheck } from "lucide-react";
import OnboardingProgress from "./OnboardingProgress";

export default function OnboardingLayout({ step, title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-slate-50 px-6 py-10">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="h-11 w-11 rounded-2xl bg-indigo-100 text-indigo-700 flex items-center justify-center">
            <ShieldCheck size={24} />
          </div>

          <div>
            <p className="font-bold text-xl text-slate-900">RevUShield</p>
            <p className="text-sm text-slate-500">Business setup</p>
          </div>
        </div>

        <OnboardingProgress step={step} />

        <div className="bg-white border border-slate-200 rounded-3xl shadow-sm p-6 md:p-8">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900">
              {title}
            </h1>

            <p className="text-slate-600 mt-2">{subtitle}</p>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
